export default (val: any): val is File =>
  typeof File !== 'undefined' && val instanceof File;
